export enum InvoiceTransplantStatus {
    All = 1,
    Transplanted = 2,
    NonTransplanted = 3
}